<template>
  <div class="flashcards-root">
    <section class="flashcard-main">
      <!-- 左侧占位dom -->
      <div class="left-side" :style="{ background: currentPage == 1 ? '#fafafb' : '#fff' }"></div>
      <!-- 上一页icon开始 -->
      <img
        v-if="currentPage == 1"
        src="@/assets/images/free-practice/disabled-left.png"
        class="arrow-img"
      />
      <img
        v-else
        @click="lastPage"
        src="@/assets/images/free-practice/chevron_left.png"
        class="arrow-img"
      />
      <!-- 上一页icon结束 -->
      <!-- 闪卡内容开始 -->
      <div class="main-card" @click="flapCard" :class="[flap ? 'flap' : 'none-flap']">
        <div id="frontCard" class="front" :class="[front ? 'f-front' : 'b-front']">
          <img src="@/assets/images/free-practice/flashcard-cover-active.png" class="card-cover" />
          <p class="main-card-title">{{ title }}</p>
          <component :is="questionKey" :currentItem="currentItem"> </component>
        </div>
        <div id="backCard" class="back" :class="[front ? 'f-back' : 'b-back']">
          <img src="@/assets/images/free-practice/flashcard-cover.png" class="card-cover" />
          <component :is="answerKey" :currentItem="currentItem"> </component>
        </div>
      </div>
      <!-- 闪卡内容结束 -->
      <!-- 下一页icon开始 -->
      <img
        @click="nextPage"
        src="@/assets/images/free-practice/chevron_right.png"
        class="arrow-img"
      />
      <!-- 下一页icon结束 -->
      <!-- 右侧占位dom -->
      <div class="right-side"></div>
    </section>
    <!-- 卡片背面选择是否正确 开始 -->
    <div class="bottom-con">
      <div class="flashcard-check-con" :class="[front ? 'hide-bottom' : 'show-bottom']">
        <p class="check-text">{{ $t('free_practice_check_text') }}</p>
        <img
          class="circle-check check-right"
          src="@/assets/images/free-practice/check_right.png"
          @click="clickCheck('1')"
        />
        <img
          class="circle-check check-wrong"
          src="@/assets/images/free-practice/check_wrong.png"
          @click="clickCheck('2')"
        />
      </div>
      <!-- 卡片背面选择是否正确 结束 -->
      <!-- 左下方页码 -->
      <CardPaganation
        class="flashcard-paganation"
        :currentPage="currentPage"
        :totalPage="totalPage"
      ></CardPaganation>
    </div>
  </div>
</template>
<script>
import CardPaganation from './common/cardPaganation'
import Meaning from './common/meaning'
import Sound from './common/sound'
import Characters from './common/characters'
export default {
  data() {
    return {
      totalPage: 1,
      currentPage: 1,
      front: true, // 正面

      flap: true, // 有翻转动画
    }
  },
  computed: {
    title() {
      switch (this.answerKey) {
        case 'Meaning':
          return 'What does this mean...?'
        case 'Sound':
          return 'How do you say...?'
        case 'Characters':
          return 'How do you write...?'
        default:
          return ''
      }
    },
    currentItem() {
      return this.renderList[this.currentPage - 1]
    },
  },
  methods: {
    // type:1正确，2错误，0未作答
    clickCheck(e) {
      this.flap = false
      this.front = true
      this.currentItem.user_answer_status = e
      if (this.currentPage == this.totalPage) {
        this.submitAnswer()
      } else {
        this.currentPage++
      }
    },
    lastPage() {
      this.flap = false
      this.front = true
      this.currentPage--
    },
    nextPage() {
      this.flap = false
      this.front = true
      if (this.currentPage == this.totalPage) {
        this.submitAnswer()
      } else {
        this.currentPage++
      }
    },
    flapCard() {
      this.flap = true
      this.front = !this.front
    },
    submitAnswer() {
      let answerRate = '0%'
      let correctCount = this.renderList.reduce((prev, current) => {
        if (!current.user_answer_status) {
          current.user_answer_status = '0'
        }
        if (current.user_answer_status == '1') {
          return prev + 1
        } else {
          return prev
        }
      }, 0)
      answerRate = (Number(((correctCount * 100) / this.renderList.length).toFixed(0)) || 0) + '%'
      this.renderList.forEach((item) => {
        Object.assign(item, {
          question_type: this.questionKey,
          answer_type: this.answerKey,
          title: this.title,
          exercise_type: '',
          describe: '',
          choose: [],
          option: [],
          user_answer: [],
          right_answer: [],
        })
      })
      const subParams = {
        answer_list: [...this.renderList],
        answer_rate: answerRate,
        section_type: 'flashcard',
        section_name: 'words',
        correctCount: correctCount,
      }
      this.$emit('saveFlashcardsRes', subParams)
    },
  },
  mounted() {
    this.totalPage = this.renderList.length
  },
  components: {
    CardPaganation,
    Meaning,
    Sound,
    Characters,
  },
  props: {
    questionKey: {
      type: String,
      default: 'Meaning',
    },
    answerKey: {
      type: String,
      default: 'Sound',
    },
    renderList: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
<style lang="scss" scoped>
@import './styles/flashcards.scss';
</style>
